import {
  getRequestEditApplicantAddressModalInitialValues,
  REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_NAME_BUILDING,
  REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_NAME_FLAT,
  REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_NAME_OWNER,
  RequestEditApplicantAddressModal,
} from '../../../RequestEditApplicantAddressModal'
import { useRequestProfileContext } from '../../../RequestProfile.hooks'
import {
  RequestProfileHeaderInfoItem,
  RequestProfileHeaderInfoItemName,
} from '../../../RequestProfileHeaderInfoItem'
import { useRequestProfileHeaderEditCategory } from '../useRequestProfileHeaderEditCategory'

import { REQUEST_PROFILE_HEADER_INFO_ITEMS_LOADING_ITEMS_LENGTH } from './useRequestProfileHeaderInfoItems.constants'
import {
  getRequestProfileHeaderInfoItemActions,
  getRequestProfileHeaderInfoItems,
  getRequestProfileHeaderInfoItemsPhaseListProps,
} from './useRequestProfileHeaderInfoItems.utils'

export function useRequestProfileHeaderInfoItems({
  arePhasesLoading,
  handleReloadRequestPhases,
  phases,
  onReloadArchivedPipelinesCount,
}) {
  const { handleCloseModal, handleUpdateEntity, requestData, setModal } =
    useRequestProfileContext()

  const { handleOpenEditCategoryModal } = useRequestProfileHeaderEditCategory({
    handleCloseModal,
    handleReloadRequestPhases,
    handleUpdateEntity,
    requestData,
    setModal,
    onReloadArchivedPipelinesCount,
  })

  const infoItems = getRequestProfileHeaderInfoItems({
    requestData,
  })

  function handleEditInfoItemSubmit({ payload }) {
    return handleUpdateEntity(payload).then(handleCloseModal)
  }

  function handleOpenEditApplicantAddressModal(focusFieldName) {
    setModal(
      <RequestEditApplicantAddressModal
        focusFieldName={focusFieldName}
        initialValues={getRequestEditApplicantAddressModalInitialValues({
          building: requestData?.building,
          flat: requestData?.flat,
          owner: requestData?.owner,
        })}
        onClose={handleCloseModal}
        onSubmit={handleEditInfoItemSubmit}
      />
    )
  }

  function handleOpenEditOwnerModal() {
    handleOpenEditApplicantAddressModal(
      REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_NAME_OWNER
    )
  }

  function handleOpenEditBuildingModal() {
    handleOpenEditApplicantAddressModal(
      REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_NAME_BUILDING
    )
  }

  function handleOpenEditFlatModal() {
    handleOpenEditApplicantAddressModal(
      REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_NAME_FLAT
    )
  }

  const infoItemsHandlers = {
    [RequestProfileHeaderInfoItemName.Building]:
      getRequestProfileHeaderInfoItemActions(handleOpenEditBuildingModal),
    [RequestProfileHeaderInfoItemName.Category]:
      getRequestProfileHeaderInfoItemActions(handleOpenEditCategoryModal),
    [RequestProfileHeaderInfoItemName.Flat]:
      getRequestProfileHeaderInfoItemActions(handleOpenEditFlatModal),
    [RequestProfileHeaderInfoItemName.Owner]:
      getRequestProfileHeaderInfoItemActions(handleOpenEditOwnerModal),
  }

  function handleRenderItem(props) {
    return <RequestProfileHeaderInfoItem {...props} requestData={requestData} />
  }

  const infoItemsProps = {
    arePhasesLoading,
    handlers: infoItemsHandlers,
    items: infoItems,
    loadingItemsLength: REQUEST_PROFILE_HEADER_INFO_ITEMS_LOADING_ITEMS_LENGTH,
    phaseListProps: getRequestProfileHeaderInfoItemsPhaseListProps(),
    phases,
    renderItem: handleRenderItem,
  }

  return {
    infoItemsProps,
  }
}
